import React from "react";
import Image from "next/image";
import Link from "next/link";

import VideoModalWithThumbnail from "@/components/seo/VideoModalWithThumbnail";
import { Button } from "@/components/ui/button";

const Hero = ({
  heroImage,
  heroVideoUrl,
  heroVideoThumbnail,
  partnerName,
  ctaLink,
  partnerLogo,
}: {
  heroImage?: string;
  heroVideoUrl?: string;
  heroVideoThumbnail?: string;
  partnerName: string;
  ctaLink: string;
  partnerLogo?: string;
}) => {
  return (
    <div className="bg-clay-200 px-5 md:px-16 md:py-28 py-16 relative">
      <Image src="/HeroGrid.png" alt="grid" fill className="absolute inset-0 w-full object-cover z-0 select-none" />
      <div className="flex flex-col lg:flex-row justify-between items-center md:gap-20 gap-10 max-w-7xl mx-auto relative">
        <div className="flex flex-col gap-12 w-full lg:max-w-2xl">
          <div className="flex flex-col md:gap-6 gap-5">
            <h1 className="font-clash font-semibold text-4xl md:text-6xl leading-[1.2] tracking-tight">
              Websites that rank, not break the bank.
            </h1>

            <p className="text-base lg:text-lg text-black leading-normal">
              {partnerLogo && `Rebolt and ${partnerName} have partnered to offer members a special discount.`} Get a
              high-quality website that is managed for you, ready in 24 hours and best of all - there&apos;s no cost up
              front.
            </p>
          </div>
          <Link href={ctaLink} target="_blank" rel="noreferrer noopener" className="w-full md:w-fit">
            <Button variant="rebolt-primary" className="h-fit py-3! px-6! md:w-fit w-full">
              Build my site
            </Button>
          </Link>
        </div>
        {heroImage ? (
          <Image
            src={heroImage}
            alt="hero media"
            width={500}
            height={500}
            className="lg:w-[560px] lg:h-[480px] w-full h-auto object-contain rounded-3xl"
          />
        ) : heroVideoUrl && heroVideoThumbnail ? (
          <VideoModalWithThumbnail
            thumbnailUrl={heroVideoThumbnail}
            videoUrl={heroVideoUrl}
            className="lg:w-[560px] lg:h-[480px] w-full h-auto object-contain"
          />
        ) : (
          <Image
            src="/rebolt-branding/rebolt-full-dark.png"
            alt="hero media"
            width={500}
            height={500}
            className="lg:w-[560px] lg:h-[480px] w-full h-auto object-contain rounded-3xl"
          />
        )}
      </div>
    </div>
  );
};

export default Hero;
